import './OrderHistory.scss';
import Component from './OrderHistory.js';
export default Component;
